<template>
  <div class="cusSerCenter">
    <breadcrumb :link-list="breadcrumbList"></breadcrumb>
    <div class="header">
      <div class="headTitle">
        <img class="headIcon" src="@/assets/image/AccountDeal/gameSelectHead/cusSerIcon.png">
        <div class="headText">客服中心</div>
        <div class="headTip">选择游戏后跳转客服列表</div>
      </div>
      <router-link :to="{name:'Home'}" class="headBack" >返回首页</router-link>
    </div>
    <!--  游戏列表 gameList -->
    <div class="gameList" >
      <gameList :gameClick="gameClick" cusSerSearch></gameList>
    </div>
  </div>
</template>
<script>

import {apiRecyclingList, apiGameList} from "@/request/API";
import breadcrumb from "@/components/breadcrumb";
import gameList from "@/components/gameList/index"
import chatApi from '@/request/customer/customerRoom'
import {Decrypt} from '@/request/customer/util.js'
export default {
  name: 'cusSerCenter',
  props: {},
  components: {
    breadcrumb,
    gameList
  },
  data() {
    return {
      // gameList 、 merchantList 、 merchantInfo
      step: 1,
      // 面包屑
      breadcrumbList: [
        {link: 'CusSerCenter', name: '客服中心'}
      ],
      // 选择的游戏
      selectGame: '',
      cursList:[],
      game_id: ''
    }
  },
  created() {
    // this.cueGrouplist()
    this.game_id = this.$route.query?.game_id
    if(this.game_id){
      this.step = 2
      apiGameList({
        game_id:this.game_id
      }).then(res => {
        this.selectGame = res.data[0]
        this.getcustomercarelist()
      })
    }
  },
  methods: {
    customClicks(item) {
      if(item.isonline == 1){
        this.$openIM({
          id: item.id,
          code: this.selectGame.game_alias,
          gameAlias: this.selectGame.game_alias,
          game_id: this.game_id,
        })
      } else {
        this.$message({
          center:true,
          type:'error',
          message:"当前客服不在线"
        })
      }
    },
    /**
     * @description: 获取客服分组列表
     * @return {*}
     */
    cueGrouplist() {
      chatApi.grouplist({
        msg: chatApi.encryptMsg({
          format: 'json',
          type: 3
        })
      }).then(res => {
        // console.log('客服分组列表',JSON.parse(Decrypt(res.result)));
      }).catch(err => {
      })
    },
    /**
     * @description: 根据分组标识获取客服列表
     * @return {*}
     */
    getcustomercarelist() {
      chatApi.getcustomercarelistbycode({
        msg: chatApi.encryptMsg({
          format: 'json',
          type: 3,
          code: this.selectGame.game_alias
        })
      }).then(res => {
        let data = JSON.parse(Decrypt(res.result))
        this.cursList = data.customercarelist
        // console.log(data);
      }).catch(err => {
      })
    },
    /**
     * 点击游戏事件
     * @param game
     */
    async gameClick(game) {
      const isOpenNewIM = (await this.$useNewIM(game.game_id)).im_type === 3
      this.$router.push({
        path: isOpenNewIM ? '/home/cusSerCenter/cusSerList' : '/home/cusSerCenter/cusSerListOld',
        query:{
          game_id:game.game_id
        }
      })
    },
    customClick(item){
      if(item.is_work === 0){
          this.$message({
            center:true,
            type:'error',
            message:"当前客服不在线"
        })
      }else {
        this.$accessLink(item.work_id)
        window.open(`${item.work_id}?u_cust_id=${this.$store.state.userData.user_id}&u_cust_name=${this.$store.state.userData.nickname}`,'_blank')
      }
    }

  },
  mounted() {
    if (this.$store.state.loginStatus) {
      sby_setuserid(this.$store.state.userData.telphone, this.$store.state.userData.nickname, this.$store.state.userData.avatar == '' ? 'https://m.pxb7.com/image/public/avatar.jpg' :this.$store.state.userData.avatar)
    } else {
      this.$message({
        type: "error",
        message: '尚未登录，请先登录。',
        center: true
      })
      this.$router.push({
        path: '/login',
        query: {
          Rurl: this.$route.path,
        },
      })
    }
  },
}
</script>

<style lang='less' scoped>
.cusSerCenter {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1200px;
  margin: 0 auto 32px;

  .header {
    width: 1200px;
    height: 100px;
    background: var(--bg-dark, #1A1D24);
    border-radius: 4px 4px 0 0;
    padding: 0 44px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;

    .headTitle {
      display: flex;
      flex-direction: row;
      align-items: center;

      .headIcon {
        width: 42px;
        height: 42px;
        object-fit: contain;
      }

      .headText {
        font-size: 24px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        text-align: CENTER;
        color: #FFFFFF;
        margin: 0 24px 0 10px;
      }

      .headTip {
        height: 28px;
        line-height: 28px;
        padding: 0 12px;
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.14);
        border: 1px solid rgba(255, 255, 255, 0.24);
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.9);
      }

    }

    .headBack {
      height: 36px;
      line-height: 34px;
      padding: 0 16px;
      border: 1px solid rgba(255, 255, 255, 0.55);
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.12);
      font-size: 15px;
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: 500;
      color: #FFFFFF;
      cursor: pointer;
      box-sizing: border-box;
      transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.2);
        border-color: rgba(255, 255, 255, 0.8);
      }
    }
  }


  .cusSerList {
    width: calc(1200px - 50px);
    background: #ffffff;
    padding: 0 25px 100px;

    .head {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 40px 18px;
      font-size: 24px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #4a4a4a;
      border-bottom: 2px solid #f0f0f0;

      img {
        width: 80px;
        height: 80px;
        border-radius: 4px;
        margin: 0 25px 0 0;
      }
    }
    .cus_main{
      display: flex;
      justify-content: flex-start;
    }
    .list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      padding: 0 6px;
      margin: 20px 0 0;

      .cusSer {
        width: 168px;
        height: 178px;
        background: #f9f9f9;
        border: 1px solid #f9f9f9;
        border-radius: 4px;
        margin: 20px 9px 0;
        cursor: pointer;
        .info{
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: 0 14px;
          padding: 26px 0 21px;
          border-bottom: 1px solid #e0e3e5;
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: #000000;
          img{
            width: 30px;
            height: 30px;
            margin: 0 0 10px;
          }

        }
        .btn{
          display: block;
          width: 121px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: var(--primary, #FF5A1F);
          color: #FFFFFF;
          border-radius: 4px;
          margin: 20px auto;
        }

      }
      .cusSer:hover{
        border: 1px solid var(--primary, #FF5A1F);
      }

      .afterWork{
        filter: grayscale(1);
        cursor: default;
      }
    }
  }

}
</style>
